<mat-accordion
  class="custom-accordion box-appearance background"
  multi="false"
  *ngIf="scenarioCalculationSteps && scenarioCalculationSteps.length !== 0"
>
  <mat-expansion-panel
    hideToggle
    *ngFor="
      let scenarioCalculationStep of scenarioCalculationSteps;
      let stepIndex = index
    "
    [ngClass]="
      scenarioCalculationStep.status === 'In Progress' ? 'highlighted' : ''
    "
    [expanded]="scenarioCalculationStep.status === 'In Progress'"
    [id]="scenarioCalculationStep.id"
    [attr.data-cy]="'step-panel-' + stepIndex"
  >
    <mat-expansion-panel-header
      [collapsedHeight]="'40px'"
      [expandedHeight]="'40px'"
      [attr.data-cy]="'step-header-' + stepIndex"
      [attr.data-copilot]="'step-' + scenarioCalculationStep.title"
    >
      <mat-panel-title>
        <mat-checkbox
          [attr.data-cy]="'step-' + scenarioCalculationStep.title"
          [disabled]="IsStepCheckboxDisabled(scenarioCalculationStep)"
          [(ngModel)]="scenarioCalculationStep.isAllChecked"
          (change)="onAllChecking($event, scenarioCalculationStep)"
          (click)="$event.stopPropagation()"
          [matTooltip]="
            scenarioCalculationStep.status === 'Pending' &&
            !IsStepCheckboxDisabled(scenarioCalculationStep)
              ? 'Skip to this step'
              : ''
          "
          [attr.aria-label]="
            scenarioCalculationStep.status === 'Pending' &&
            !IsStepCheckboxDisabled(scenarioCalculationStep)
              ? 'Skip to this step'
              : null
          "
        >
        </mat-checkbox>
        {{ stepIndex + 1 }}
        <span
          [class]="
            scenarioCalculationStep.status === 'Completed' ? 'line-through' : ''
          "
          [matTooltip]="scenarioCalculationStep.title"
          >{{ ". " + scenarioCalculationStep.title }}</span
        >
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="contents-container">
      @if (disableChecklist) {
        <div class="information" [attr.data-cy]="'jump-run-banner'">
          @if (jumpRun) {
            <i class="fa-solid fa-spinner fa-spin"></i>
            Running "{{ jumpRun.currentWorkflowName }}" ({{ jumpRun.index }} of
            {{ jumpRun.total }})&mdash;this can take several minutes. The
            checklist is read-only until it finishes.
          } @else {
            <i class="fa-solid fa-exclamation-triangle"></i>
            We are finalizing the Country Calculators. Your checklist will be available shortly.
          }
        </div>
      }
      @if (
        scenarioCalculationStep.status === "In Progress" &&
        scenarioCalculationStep.countryCode !== "OECD" &&
        scenarioCalculationStep.scenarioType !== "TXP"
      ) {
        <div class="information">
          <i class="fa-solid fa-circle-info"></i>
          Please return to the OECD Calculator to continue the Step-by-Step
          Process.
        </div>
      }

      <ul class="help-and-support-list">
        <li
          [ngClass]="{
            pending: checklist.status === 'Pending',
            'in-progress': checklist.status === 'In Progress',
            completed: checklist.status === 'Completed',
          }"
          *ngFor="
            let checklist of scenarioCalculationStep.checklists;
            let checklistIndex = index
          "
        >
          <particle-dynamic-tooltip-container
            [openOption]="
              checklist.status === 'In Progress' && !checklist.isCheckboxEnabled
                ? 'none'
                : 'hover'
            "
            [cssClass]="'step-tooltip'"
            [htmlElement]="
              checklist.status === 'In Progress' && !checklist.isCheckboxEnabled
                ? ''
                : checklist?.toolTip && checklist.status !== 'In Progress'
                  ? checklist.toolTip
                  : checklist.title
            "
            [width]="220"
            [theme]="'dark'"
            [matTooltip]="
              checklist.status === 'In Progress' && !checklist.isCheckboxEnabled
                ? workflowMessage +
                  (checklist.hasWorkflow ? 'workflow' : 'action')
                : ''
            "
          >
            @if (checklist.isHyperlinkEnabled) {
              <div
                class="checkbox-link-container"
                [ngClass]="
                  checklist.status === 'In Progress' ? 'active-state' : ''
                "
              >
                <mat-checkbox
                  [attr.data-cy]="'substep-' + checklist.title"
                  [disabled]="
                    isChecklistCheckboxDisabled(scenarioCalculationStep, checklist)
                  "
                  [(ngModel)]="checklist.isChecked"
                  (change)="
                    onChecklistCheckboxChange(
                      $event.checked,
                      scenarioCalculationStep,
                      checklist
                    )
                  "
                >
                </mat-checkbox>
                <a
                  (click)="
                    onHyperlinkClick(scenarioCalculationStep, checklist, checklistIndex)
                  "
                  [attr.data-cy]="'substep-link-' + checklist.title"
                  ><span>{{
                    getChecklistFormatedText(
                      stepIndex,
                      checklist.title,
                      checklistIndex
                    )
                  }}</span></a
                >
              </div>
            } @else {
              <div
                [ngClass]="
                  checklist.status === 'In Progress' &&
                  checklist.isCheckboxEnabled
                    ? 'active-state'
                    : ''
                "
              >
                <mat-checkbox
                  [attr.data-cy]="'substep-' + checklist.title"
                  [disabled]="
                    isChecklistCheckboxDisabled(scenarioCalculationStep, checklist)
                  "
                  [(ngModel)]="checklist.isChecked"
                  [ngClass]="
                    checklist.status === 'In Progress' &&
                    checklist.isCheckboxEnabled
                      ? 'active-state'
                      : ''
                  "
                  [ngClass]="
                    checklist.status === 'In Progress'
                      ? 'active-state-text'
                      : ''
                  "
                  (change)="
                    onChecklistCheckboxChange(
                      $event.checked,
                      scenarioCalculationStep,
                      checklist
                    )
                  "
                  >{{
                    getChecklistFormatedText(
                      stepIndex,
                      checklist.title,
                      checklistIndex
                    )
                  }}
                </mat-checkbox>
              </div>
            }
          </particle-dynamic-tooltip-container>

          @if (checklist.status === "In Progress") {
            <div
              (click)="onDescriptionHyperlinkClick($event, checklist)"
              class="tooltip-as-description"
              [attr.data-cy]="'substep-description-' + checklist.title"
              [innerHTML]="
                checklist?.toolTip
                  ? checklist.toolTip
                  : (checklist.title | sanitizeHtml)
              "
            ></div>
          }

          <button
            *ngIf="checklist.hasWorkflow"
            [disabled]="!checklist.isWorkflowEnabled"
            matTooltip="{{ checklist.workflowName }}"
            mat-stroked-button
            class="m-t-10 disable-btn-tooltip"
            [attr.data-cy]="'substep-workflow-' + checklist.workflowName"
            (click)="onExecuteOtherWorkflow(scenarioCalculationStep, checklistIndex)"
          >
            <i class="fa-regular fa-shuffle"></i>
            <span>{{ checklist.workflowName }}</span>
            <i
              *ngIf="checklist.isMandatory"
              class="fa-solid fa-asterisk"
              matTooltip="Mandatory"
            ></i>
          </button>
          <div
            class="m-t-10 w-p-100"
            *ngFor="
              let additionalCheckListItem of checklist.additionalCheckListItems
            "
          >
            <p class="or-text"
              *ngIf="
                checklist.hasWorkflow &&
                additionalCheckListItem.workflowName !== ''
              "
            >
              Or
            </p>
            <button
              *ngIf="
                checklist.hasWorkflow &&
                additionalCheckListItem.workflowName !== ''
              "
              [disabled]="!checklist.isWorkflowEnabled"
              matTooltip="{{ additionalCheckListItem.workflowName }}"
              mat-stroked-button
              class="m-t-10 disable-btn-tooltip"
              [attr.data-cy]="
                'substep-workflow-' + additionalCheckListItem.workflowName
              "
              (click)="
                onExecuteOtherWorkflow(
                  scenarioCalculationStep,
                  checklistIndex,
                  additionalCheckListItem
                )
              "
            >
              <i class="fa-regular fa-shuffle"></i>
              <span>{{ additionalCheckListItem.workflowName }}</span>
              <i
                *ngIf="checklist.isMandatory"
                class="fa-solid fa-asterisk"
                matTooltip="Mandatory"
              ></i>
            </button>
          </div>
          <button
            *ngIf="checklist.hasCommandButton"
            [disabled]="
              checklist.status != 'In Progress' || checklist.isButtonDisabled
            "
            matTooltip="{{ checklist.title }}"
            mat-stroked-button
            class="m-t-10"
            [attr.data-cy]="'substep-workflow-' + checklist.title"
            (click)="onHyperlinkClick(scenarioCalculationStep, checklist, checklistIndex)"
          >
            <span class="text">
              <i
                *ngIf="checklist?.navigationCommand?.icon"
                [ngClass]="checklist?.navigationCommand?.icon"
              ></i>
              {{ checklist.title }}
            </span>

            <i *ngIf="checklist.isMandatory" class="fa-solid fa-asterisk"></i>
          </button>
        </li>
      </ul>
      <footer>
        <div
          *ngIf="
            scenarioCalculationStep.status === 'Completed' &&
            scenarioCalculationStep?.stepCompletedDate != null
          "
        >
          <caption>
            {{
              scenarioCalculationStep.status
            }}
            -
            {{
              scenarioCalculationStep?.stepCompletedDate
            }}
          </caption>
        </div>
        <div
          *ngIf="
            scenarioCalculationStep.status !== 'Completed' ||
            (scenarioCalculationStep.status === 'Completed' &&
              scenarioCalculationStep?.stepCompletedDate == null)
          "
        >
          <caption>
            {{
              scenarioCalculationStep.status
            }}
          </caption>
        </div>

        <particle-dynamic-tooltip-container
          [cssClass]="'step-tooltip'"
          [openOption]="scenarioCalculationStep.isAllChecked ? 'none' : 'hover'"
          [text]="
            !scenarioCalculationStep.isAllChecked
              ? 'Please complete all checklist items before continuing.'
              : null
          "
          [width]="220"
          [theme]="'dark'"
        >
          <button
            *ngIf="scenarioCalculationStep.status === 'In Progress'"
            [disabled]="
              !scenarioCalculationStep.isAllChecked ||
              scenarioCalculationStep.isMarkAsCompleteDisabled ||
              disableChecklist
            "
            mat-button
            class="action-button m-t-10"
            [attr.data-cy]="'btn-mark-as-complete'"
            (click)="onMarkAsComplete(scenarioCalculationStep)"
          >
            <span>Mark as Complete</span>
          </button>
        </particle-dynamic-tooltip-container>

        <button
          *ngIf="scenarioCalculationStep.status === 'Completed'"
          mat-button
          class="action-button m-t-10"
          [disabled]="scenarioCalculationStep.status === 'Completed'"
          [attr.data-cy]="'btn-completed'"
        >
          <span>Completed</span>
        </button>
      </footer>
    </div>
  </mat-expansion-panel>
</mat-accordion>
